import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { COLOR_PRIMARY } from "../../../constants";
import "../../css/brand-modal.css";

/** Colores corporativos y de los procesos (mismos del dashboard) */
export const BRAND = {
  navy: COLOR_PRIMARY || "#1E3A5F",
  blue: "#3A6EA5",
  orange: "#F59E0B",
  coral: "#F4623A",
  green: "#22A745",
  red: "#D9363E",
};

/** Tema de antd para los modales corporativos */
export const BRAND_MODAL_THEME = {
  token: { colorPrimary: BRAND.navy, borderRadius: 8 },
  components: {
    Table: {
      headerBg: "#f1f5f9",
      headerColor: BRAND.navy,
      headerSplitColor: "transparent",
      rowHoverBg: `${BRAND.navy}0D`,
      borderColor: "#e6ebf2",
    },
    Tabs: {
      inkBarColor: BRAND.orange,
      itemSelectedColor: BRAND.navy,
      itemHoverColor: BRAND.blue,
    },
    Card: {
      headerBg: "#f8fafc",
      colorTextHeading: BRAND.navy,
    },
    Statistic: {
      titleFontSize: 13,
    },
  },
};

export const BRAND_MODAL_STYLES = {
  header: {
    padding: "16px 24px",
    marginBottom: 0,
    borderBottom: "1px solid #e6ebf2",
    borderTop: `4px solid ${BRAND.navy}`,
    borderRadius: "8px 8px 0 0",
  },
  body: { padding: "16px 24px" },
  footer: {
    padding: "12px 24px",
    marginTop: 0,
    background: "#f8fafc",
    borderTop: "1px solid #e6ebf2",
    borderRadius: "0 0 8px 8px",
  },
};

/** Boton X rojo para el `closeIcon` del Modal */
export const BrandModalCloseIcon = (
  <span className="brand-modal-close">
    <CloseOutlined />
  </span>
);

interface BrandModalTitleProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

/** Titulo con icono en cuadro tintado, titulo y subtitulo */
export const BrandModalTitle = ({
  icon,
  title,
  subtitle,
  children,
}: BrandModalTitleProps) => (
  <div
    style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}
  >
    <div
      style={{
        width: 40,
        height: 40,
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 20,
        color: BRAND.navy,
        background: `${BRAND.navy}1A`,
      }}
    >
      {icon}
    </div>
    <div>
      <div
        style={{
          fontWeight: 700,
          fontSize: 17,
          color: BRAND.navy,
          lineHeight: 1.2,
        }}
      >
        {title}
      </div>
      {subtitle ? (
        <div style={{ fontWeight: 400, fontSize: 12.5, color: "#6b7280" }}>
          {subtitle}
        </div>
      ) : null}
    </div>
    {children}
  </div>
);
